
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'SubheaderItem',
})
export default class SubheaderItem extends Vue {
    @Prop([String, Object]) private nameToGo: string | any;
    @Prop(Boolean) private isActive: boolean;
    @Prop(String) private label: string;
    @Prop(String) private path: string;

    private goTo(): void {
        this.nameToGo
            ? this.nameToGo !== this.$router.currentRoute.name
                ? this.$router.push({ name: this.nameToGo })
                : null
            : null;
    }
}
